import type { PaymentMethod } from "@/types/payment";

import { getPaymentMethodsByPatientId } from "./payment";

export const paymentQueryKeys = {
  all: ["billing", "payment"] as const,
  methods: (patientId: string) =>
    [...paymentQueryKeys.all, "methods", patientId] as const,
};

export const paymentQueryOptions = {
  methods: (patientId: string) => ({
    queryKey: paymentQueryKeys.methods(patientId),
    queryFn: () => getPaymentMethodsByPatientId(patientId),
    select: (data: PaymentMethod[] | null) => data ?? [],
  }),
};
